<template>
  <div id="mapa" class="mapa">
     <GmapMap
      :center="centerMap"
      ref="gMapRef"
      :style="css"
    >
      <slot></slot>
      <GmapMarker
        :center="centerMap"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
      />
    </GmapMap>
  </div>
</template>
<script>
import swal from 'sweetalert2'
import {gmapApi} from 'vue2-google-maps'
import {setTimeout} from 'timers'
export default {
  name: 'Mapa',
  props: {
    points: Array,
    enableInfowindow: Boolean,
    fitBounds: Boolean,
    zoom: Number,
    css: String,
    latitude: String,
    longitude: String,
    code: String,
    endereco: String
  },
  computed: {
    google: gmapApi
  },
  data () {
    return {
      markers: [],
      categorias: [],
      directionsDisplay: null,
      centerMap: {lat: -27.185859, lng: -52.518178}
    }
  },
  watch: {
    points: {
      deep: true,
      handler () {
        this.resetMarkers()
      }
    },
    code (newVal, oldVal) {
      if (newVal != null) {
        let index = this.categorias.indexOf(newVal)
        if (index === -1) {
          this.categorias.push(newVal)
          this.getNearby(newVal)
        } else {
          this.removeMarkers()
          this.categorias.splice(index, 1)
        }
      }
    },
    endereco (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.calcRoute()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.generateMap()
    }, 1000)
  },
  methods: {
    generateMap () {
      let centerPoint = null
      let mapZoom = null
      centerPoint = {lat: parseFloat(this.points[0].latitude), lng: parseFloat(this.points[0].longitude)}
      // this.centerMap = {lat: parseFloat(this.points[0].latitude), lng: parseFloat(this.points[0].longitude)}

      mapZoom = this.zoom

      var mapOptions = {
        mapTypeControl: false, // desativa opcao de escolha de mapa
        mapTypeId: 'roadmap', // desativa opcao de escolha de mapa
        panControl: false, // desativa movimentacao no mapa
        disableDefaultUI: false,
        center: centerPoint
      }
      this.$refs.gMapRef.$mapPromise.then((map) => {
        map.setOptions(mapOptions)
        this.setMarkers(map)
        map.setZoom(mapZoom)
      })
    },
    resetMarkers () {
      this.markers.forEach(marker => {
        marker.setMap(null)
      })
      this.$refs.gMapRef.$mapPromise.then((map) => {
        this.setMarkers(map)
      })
    },
    setMarkers (gMap) {
      if (!this.points) {
        return []
      }
      // var bounds = new this.google.maps.LatLngBounds()
      this.points.forEach(element => {
        var marker = new this.google.maps.Marker({
          position: {
            lat: parseFloat(element.latitude),
            lng: parseFloat(element.longitude)
          },
          map: gMap,
          icon: element.icon
        })
        if (this.enableInfowindow) {
          marker.addListener('click', () => {
            var infoWindow = this.generateInfoWindow(element.title, element.description ? element.description : '')
            infoWindow.open(gMap, marker)
          })
        }
        this.markers.push(marker)
      })
      this.google.maps.event.trigger(this.markers[0], 'click')
    },
    generateInfoWindow (title, description) {
      var contentString =
        '<div id="content">' +
        '<div class="box-map">' +
        '<h2 class="map-title">' + title + '</h2>' +
        '<p>' + description + '</p></div></div>'
      var infowindow = new this.google.maps.InfoWindow({
        content: contentString
      })
      this.google.maps.event.addListener(infowindow, 'domready', function () {
        /* eslint-disable */
        var iwOuter = $('.gm-style-iw')
        var iwBackground = iwOuter.prev()
        iwBackground.children(':nth-child(2)').css({'display': 'none'})
        iwBackground.children(':nth-child(2)').css({'mox-display': 'none'})
        iwBackground.children(':nth-child(4)').css({'display': 'none'})
        iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'none'})
        iwBackground.children(':nth-child(3)').css({'margin-left': '-15px'})
        iwBackground.children(':nth-child(1)').css({'margin-left': '-15px'})
        iwOuter.parent().parent()
        var iwCloseBtn = iwOuter.next()
        iwCloseBtn.css({top: '10px', right: '-5px'})
      })
      return infowindow
    },
    createMarker (place) {
      this.$refs.gMapRef.$mapPromise.then((map) => {
        let markerPts = new this.google.maps.Marker({
          map: map,
          position: place.geometry.location,
          icon: '../../static/' + this.code + '.png',
          title: place.name,
          type: this.code
        })

        markerPts.addListener('click', () => {
          var infoWindow = this.generateInfoWindow(place.name, '')
          infoWindow.open(map, markerPts)
        })
        this.markers.push(markerPts)
      })
    },
    removeMarkers () {
      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].type === this.code) {
          this.markers[i].setMap(null)
        }
      }
    },
    callback (results, status) {
      if (status === this.google.maps.places.PlacesServiceStatus.OK) {
        for (var i = 0; i < results.length; i++) {
          this.createMarker(results[i])
        }
      }
    },
    getNearby (type) {
      this.$refs.gMapRef.$mapPromise.then((map) => {
        let lookFor
        switch (type) {
          case 'recreation':
            lookFor = ['bar', 'book_store', 'night_club', 'movie_theater',
              'movie_rental', 'library', 'amusement_park', 'art_gallery']
            break
          case 'education':
            lookFor = ['school', 'university']
            break
          case 'health':
            lookFor = ['health', 'doctor', 'dentist', 'pharmacy', 'hospital', 'gym']
            break
          case 'food':
            lookFor = ['bakery', 'cafe', 'food', 'restaurant', 'grocery_or_supermarket']
            break
          case 'comfort':
            lookFor = ['taxi_stand', 'store', 'beauty_salon', 'bus_station', 'laundry']
            break
        }

        let request = {
          location: new this.google.maps.LatLng(this.latitude, this.longitude),
          radius: 750,
          types: lookFor,
          language: 'pt-BR'
        }

        let service = new this.google.maps.places.PlacesService(map)
        service.nearbySearch(request, this.callback)
      })
    },
    calcRoute () {
      // Ponto Inicial do trajeto
      let start = this.endereco

      // Ponto Final do trajeto
      let end = new this.google.maps.LatLng(this.latitude, this.longitude)

      // Dados Requisitados
      let request = {
        origin: start,
        destination: end,
        travelMode: this.google.maps.TravelMode.DRIVING
      }
      setTimeout(() => {
        this.$refs.gMapRef.$mapPromise.then((map) => {
          let rendererOptions = {
            map: map
          }
          let directionsService = new this.google.maps.DirectionsService()

          // Verificar Trajeto
          directionsService.route(request, (response, status) => {
            if (status === this.google.maps.DirectionsStatus.OK) {
              if (this.directionsDisplay) {
                this.directionsDisplay.setMap(null)
                this.directionsDisplay.setPanel(null)
                this.directionsDisplay = null
              }
              this.directionsDisplay = new this.google.maps.DirectionsRenderer(rendererOptions)
              this.directionsDisplay.setMap(map)

              this.directionsDisplay.setDirections(response)
              this.liberaRota()
            } else {
              swal(
                'Ops :(',
                'Não encontramos nenhuma rota para este endereço',
                'error'
              )
              this.liberaRota()
            }
          })
        })
      })
    },
    liberaRota () {
      this.$emit('liberaRota')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.mapa{
  height: 29em;
  margin: 0;
  @media (max-width: 767px) {
    height: 350px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaMapa.vue